import React from 'react';
import Icon from '../../../components/AppIcon';

const verdictConfig = {
  fair: { label: 'Fair Value', color: '#00FF88', bg: 'rgba(0,255,136,0.1)' },
  overpriced: { label: 'Overpriced', color: '#FF4444', bg: 'rgba(255,68,68,0.1)' },
  underpriced: { label: 'Underpriced', color: '#00D4FF', bg: 'rgba(0,212,255,0.1)' },
};

const ReportCard = ({ report, onView, onDownload, onDelete }) => {
  const verdict = verdictConfig?.[report?.verdict] || verdictConfig?.fair;
  return (
    <div className="bg-card rounded-xl border border-border p-5 hover:border-primary/30 transition-all duration-200">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground truncate">{report?.address}</h3>
          <p className="text-sm text-muted-foreground">{report?.suburb} · {report?.date}</p>
        </div>
        <span className="px-2 py-1 rounded-lg text-xs font-medium flex-shrink-0" style={{ background: verdict?.bg, color: verdict?.color }}>{verdict?.label}</span>
      </div>
      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="text-center p-2 rounded-lg bg-muted/30">
          <p className="text-sm font-bold text-foreground">{report?.price}</p>
          <p className="text-xs text-muted-foreground">Listed</p>
        </div>
        <div className="text-center p-2 rounded-lg bg-muted/30">
          <p className="text-sm font-bold" style={{ color: '#00D4FF' }}>{report?.offerMin}</p>
          <p className="text-xs text-muted-foreground">Min Offer</p>
        </div>
        <div className="text-center p-2 rounded-lg bg-muted/30">
          <p className="text-sm font-bold" style={{ color: '#FFAA00' }}>{report?.confidence}%</p>
          <p className="text-xs text-muted-foreground">Confidence</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button onClick={() => onView?.(report)} className="flex-1 py-2 rounded-lg text-sm font-medium transition-all" style={{ background: 'rgba(0,212,255,0.1)', color: '#00D4FF', border: '1px solid rgba(0,212,255,0.2)' }}>View Report</button>
        <button onClick={() => onDownload?.(report)} className="p-2 rounded-lg transition-all hover:bg-muted" title="Download PDF">
          <Icon name="Download" size={16} color="#888" />
        </button>
        <button onClick={() => onDelete?.(report?.id)} className="p-2 rounded-lg transition-all hover:bg-red-500/10" title="Delete">
          <Icon name="Trash2" size={16} color="#888" />
        </button>
      </div>
    </div>
  );
};

export default ReportCard;
